/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState } from "react";
import defVImage from "../../../../_legacy/images/no-image-vertical.png";
import defHImage from "../../../../_legacy/images/no-image-horizontal.png";

export function ProcedureImage({ src, alt, openLightbox, imageType }) {
  const [image45Height, setImage45Height] = useState(null);
  const [image90Height, setImage90Height] = useState(null);

  const handleImageLoad = (event) => {
    const image = event.target;

    const aspectRatio = image.naturalWidth / image.naturalHeight;
    const containerWidth = image.parentElement.clientWidth;
    const calculatedHeight = containerWidth / aspectRatio;
    const finalHeight = Math.min(calculatedHeight, 400);

    if (imageType === "vertical") {
      setImage90Height(finalHeight);
    } else {
      setImage45Height(finalHeight);
    }
  };

  const handleError = (event) => {
    const { imageType } = event.currentTarget.dataset;
    switch (imageType) {
      case "vertical":
        event.target.src = defVImage;
        break;
      case "horizontal":
        event.target.src = defHImage;
        break;

      default:
        break;
    }
  };

  const img90Styles = {
    maxWidth: "100%",
    height: image90Height ? `${image90Height}px` : "auto",
    objectFit: "contain",
  };

  const img45Styles = {
    maxWidth: "100%",
    height: image45Height ? `${image45Height}px` : "auto",
    objectFit: "contain",
  };

  const defaultImage = imageType === "vertical" ? defVImage : defHImage;

  return (
    <img
      onClick={(e) => openLightbox(0, e, src)}
      onError={handleError}
      onLoad={handleImageLoad}
      style={imageType === "vertical" ? img90Styles : img45Styles}
      src={src ? src : defaultImage}
      alt={alt}
    />
  );
}
